// export const srArtContext = '/srArt/newsInfo'

export default [{
        path: `/appreciate`,
        name: '馆藏鉴赏',
        meta: {
            title: '馆藏鉴赏-上饶美术馆',
            // keepAlive: true
        },
        component: () =>
            import ('../views/appreciate/Adv.vue'),
    },
    {
        path: `/appreciate/collectionList`,
        name: '馆藏鉴赏-藏品列表',
        meta: {
            title: '藏品列表-上饶美术馆',
            // keepAlive: true
        },
        component: () =>
            import ('../views/appreciate/Count.vue'),
    },
    {
        path: `/appreciate/vtour`,
        name: '馆藏鉴赏-VR展示',
        meta: {
            title: '藏品列表-上饶美术馆',
            // keepAlive: true
        },
        component: () =>
            import ('../views/appreciate/Vtour.vue'),
    },
    {
        path: `/appreciate/detail`,
        name: '馆藏鉴赏藏品详情',
        meta: {
            title: '藏品详情-上饶美术馆',
            // keepAlive: true
        },
        component: () =>
            import ('../views/appreciate/About.vue'),
    }


]